import { extend } from 'vee-validate';
import { required, excluded, max } from 'vee-validate/dist/rules';
import { formValidators } from '@gitlab/ui/dist/utils';
import { validEmail } from './rules/valid_email';
import { noDoubleQuotes } from './rules/no_double_quotes';

const noEmojis = formValidators.noEmojis("{_field_} can't contain emojis.");

export default function initValidation() {
  // vee-validate treats any returned string, including '', as a failure
  extend('noEmoji', { validate: (value) => noEmojis(value) || true });
  extend('validEmail', validEmail);
  extend('noDoubleQuotes', noDoubleQuotes);
  extend('required', {
    ...required,
    message: '{_field_} is required.',
  });
  extend('excluded', {
    ...excluded,
  });
  extend('max', {
    ...max,
    message: '{_field_} must be {length} characters or less.',
  });
}
